module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customer":"Customer","customerMissing":"Customer missing","to":"To","toMissing":"Delivery party missing","from":"From","fromMissing":"Despatch party missing"},"no":{"customer":"Kunde","customerMissing":"Kunde mangler","to":"Til","toMissing":"Mottaker mangler","from":"Fra","fromMissing":"Henteaddresse mangler"}}')
  delete Component.options._Ctor
}
